<template>
  <div>
    <v-row class="list__item">
        <v-btn
          class="v-action-btn rounded-lg"
          :width="width || '100%'"
          :height="height || '44px'"
          :color="color || '#004fac'"
          @click="onExportWildberriesStocks"
          :disabled="stocksReportFetching"
          :loading="stocksReportFetching"
        >
          <v-icon size="18">mdi-microsoft-excel</v-icon>
          <span class="ml-2">Экспорт остатков для Wildberries</span>
        </v-btn>
    </v-row>
    <v-row class="list__item mt-4">
        <v-btn
          class="v-action-btn rounded-lg"
          :width="width || '100%'"
          :height="height || '44px'"
          :color="color || '#004fac'"
          @click="onExportWildberriesPrices"
          :disabled="pricesReportFetching"
          :loading="pricesReportFetching"
        >
          <v-icon size="18">mdi-microsoft-excel</v-icon>
          <span class="ml-2">Экспорт цен для Wildberries</span>
        </v-btn>
    </v-row>
  </div>
</template>

<script>
import ColorPaletteMixin from "@/mixins/ColorPalette";
import { mapFields } from "vuex-map-fields";
import ServiceFacade from "@/services/ServiceFacade";

export default {
  name: "WildberriesPopupContent",
  props: {
    downloadLinks: Object,
  },
  mixins: [ColorPaletteMixin],
  data() {
    return {
      stocksReportFetching: false,
      pricesReportFetching: false,
    }
  },
  computed: {
    ...mapFields("formModels", ["dataSourceSettingsForm"]),
  },
  methods: {
    async onExportWildberriesStocks() {
      this.stocksReportFetching = true;
      await ServiceFacade.downloadWildberriesStocks();
      this.stocksReportFetching = false;
    },
    async onExportWildberriesPrices() {
      this.pricesReportFetching = true;
      await ServiceFacade.downloadWildberriesPrices();
      this.pricesReportFetching = false;
    },
  },
};
</script>

<style>
</style>